const MIN_LENGTH_PASSWORD = 6
const MIN_LENGTH_TICKED_CODE = 6
export { MIN_LENGTH_PASSWORD, MIN_LENGTH_TICKED_CODE }
